import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import { DELETE_PLC_SAFETY_ZONE_DEPENDENCY } from './actionTypes';
import { deletePlcSafetyZoneDependencySuccessful, deletePlcSafetyZoneDependencyFailed } from './actions';
import { getPlcSafetyAPI } from '../../../api/plcSafety';

const plcSafetyAPI = getPlcSafetyAPI();

function* deleteZoneDependency({ payload: { zoneDependency } }) {
  try {
    const response = yield call(
      plcSafetyAPI.deleteZoneDependency,
      zoneDependency.token,
      zoneDependency.id,
    );
    if (response.message) {
      yield put(deletePlcSafetyZoneDependencySuccessful(response.message));
    } else throw response.error;
  } catch (error) {
    yield put(deletePlcSafetyZoneDependencyFailed(error));
  }
}

export function* watchDeletePlcSafetyZoneDependency() {
  yield takeEvery(DELETE_PLC_SAFETY_ZONE_DEPENDENCY, deleteZoneDependency);
}

function* deletePlcSafetyZoneDependencySaga() {
  yield all([fork(watchDeletePlcSafetyZoneDependency)]);
}

export default deletePlcSafetyZoneDependencySaga;
